import { HelpCircle } from 'lucide-react';

import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'components/ui/tooltip';

/**
 * Help marker for a property label. Shows the supporting text coming from the
 * dd file (property.info.displayName) in a wide tooltip. Renders nothing when
 * there is no text, or when the text is just the label again.
 */
const PropertyInfoTooltip = ({ text, label, side }) => {

    const helpText = ('' + (text || '')).trim();

    if (helpText === '') {
        return null;
    }

    if (label && helpText.toLowerCase() === ('' + label).trim().toLowerCase()) {
        return null;
    }

    return (
        <TooltipProvider delayDuration={150}>
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        type="button"
                        aria-label={helpText}
                        className="ml-1.5 inline-flex shrink-0 cursor-help items-center border-0 bg-transparent p-0 leading-none focus:outline-none">
                        <HelpCircle size={17} strokeWidth={2.25} style={{ color: 'var(--brand-color1)' }} />
                    </button>
                </TooltipTrigger>
                <TooltipContent side={side || 'right'} align="start">
                    {helpText}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default PropertyInfoTooltip;
